import React, { useState, useContext, useEffect } from "react";
import { firestore } from "./firebase";
import axios from "axios";
import { useLocation } from "react-router-dom";
export const DataContext = React.createContext();
export const useData = () => useContext(DataContext);
export const DataProvider = ({ children, ...initOptions }) => {
    const [unternehmen, setUnternehmen] = useState([]);
    const [filteredUnternehmen, setFilteredUnternehmen] = useState([]);
    const [filteredExperten, setFilteredExperten] = useState([]);

    const [experten, setExperten] = useState([]);
    const [fields, setFields] = useState([]);
    const [interests, setInterests] = useState([]);
    const [fieldFilter, setFieldFilter] = useState("all");
    const [interestFilter, setInterestFilter] = useState("all");
    const location = useLocation();
    const { pathname } = useLocation();
    const assetUrl =
        process.env.NODE_ENV === "development"
            ? ""
            : "/wp-content/uploads/reactapps/app-1279";

    useEffect(() => {
        window.scroll(0, 0);
    }, [pathname]);

    useEffect(() => {
        setFilteredUnternehmen([...unternehmen]);
        setFilteredExperten([...experten]);
        setFieldFilter("all");
        setInterestFilter("all");
    }, [pathname]);

    useEffect(() => {
        if (fieldFilter !== "all" && interestFilter === "all") {
            const data = [...unternehmen].filter((co) =>
                fieldFilter.every((val) => co.fields.includes(val))
            );
            setFilteredUnternehmen(data);
        }
        if (interestFilter !== "all" && fieldFilter === "all") {
            const data = [...unternehmen].filter((co) => {
                return interestFilter.every((val) =>
                    co.interested.includes(val)
                );
            });
            setFilteredUnternehmen(data);
        }

        if (interestFilter !== "all" && fieldFilter !== "all") {
            const data = [...unternehmen]
                .filter((co) =>
                    fieldFilter.every((val) => co.fields.includes(val))
                )
                .filter((co) =>
                    interestFilter.every((val) => co.interested.includes(val))
                );
            setFilteredUnternehmen(data);
        }

        if (interestFilter === "all" && fieldFilter === "all") {
            setFilteredUnternehmen([...unternehmen]);
        }
    }, [unternehmen, fieldFilter, interestFilter]);

    useEffect(() => {
        if (fieldFilter !== "all" && interestFilter === "all") {
            const data = [...experten].filter((co) =>
                fieldFilter.every((val) => co.fields.includes(val))
            );
            setFilteredExperten(data);
        }
        if (interestFilter !== "all" && fieldFilter === "all") {
            const data = [...experten].filter((co) =>
                interestFilter.every((val) => co.interested.includes(val))
            );
            setFilteredExperten(data);
        }

        if (interestFilter !== "all" && fieldFilter !== "all") {
            const data = [...experten]
                .filter((co) =>
                    fieldFilter.every((val) => co.fields.includes(val))
                )
                .filter((co) =>
                    interestFilter.every((val) => co.interested.includes(val))
                );
            setFilteredExperten(data);
        }

        if (interestFilter === "all" && fieldFilter === "all") {
            setFilteredExperten([...experten]);
        }
    }, [experten, fieldFilter, interestFilter]);

    useEffect(() => {
        if (!unternehmen.empty) {
            let fieldArray = [];
            unternehmen.forEach((comp) => {
                if (!comp.fields.empty) {
                    comp.fields.forEach((tag) => {
                        if (fieldArray.indexOf(tag) === -1) {
                            fieldArray.push(tag);
                        }
                    });
                }
            });
            setFields(fieldArray);
            let interestArray = [];
            unternehmen.forEach((comp) => {
                if (!comp.interested.empty) {
                    comp.interested.forEach((tag) => {
                        if (interestArray.indexOf(tag) === -1) {
                            interestArray.push(tag);
                        }
                    });
                }
            });
            setInterests(interestArray);
        }
    }, [unternehmen]);

    useEffect(() => {
        const subscriber = firestore
            .collection("unternehmen")
            .where("approved", "==", true)
            .onSnapshot((querySnapshot) => {
                const arr = [];
                if (querySnapshot) {
                    querySnapshot.forEach((doc) => {
                        arr.push({
                            id: doc.id,
                            ...doc.data(),
                        });
                    });
                }
                setUnternehmen(arr);
                return () => subscriber();
            });
        const subscriber2 = firestore
            .collection("experten")
            .where("approved", "==", true)
            .onSnapshot((querySnapshot) => {
                const arr = [];
                if (querySnapshot) {
                    querySnapshot.forEach((doc) => {
                        arr.push({
                            id: doc.id,
                            ...doc.data(),
                        });
                    });
                }
                setExperten(arr);
                return () => subscriber2();
            });
    }, []);

    function getColor(category) {
        switch (category) {
            case "unternehmen":
                return "#a82717";
            case "startup":
                return "#C99F31";
            case "forschung":
                return "#73928D";

            default:
                return "rgb(168, 39, 23)";
        }
    }

    function getCatLabel(category) {
        switch (category) {
            case "unternehmen":
                return "Unternehmen";
            case "startup":
                return "Start-Up";
            case "forschung":
                return "Forschung";
            default:
                return "";
        }
    }

    function updateFilter(type, value) {
        if (type === "fields") {
            setFieldFilter(value);
        }
        if (type === "interests") {
            setInterestFilter(value);
        }
    }
    const exports = {
        unternehmen,
        filteredUnternehmen,
        filteredExperten,
        experten,
        getColor,
        getCatLabel,
        fields,
        interests,
        updateFilter,
        fieldFilter,
        interestFilter,
        assetUrl,
    };

    return (
        <DataContext.Provider value={exports}>{children}</DataContext.Provider>
    );
};
